import { THEMES as r } from "./theme-list.js";
class a {
  THEMES;
  /**
   * Constructor for the theme definitions.
   */
  constructor() {
    this.THEMES = r;
  }
  async getCss(t) {
    return (await (t === "slate-v1" ? import("./styles/slate-v1.scss.js") : import("./styles/slate-v4.scss.js"))).default;
  }
}
export {
  a as StandardThemeDefinitions
};
//# sourceMappingURL=standard-theme-definitions.js.map
